import GrilleMixedController from './grille-mixed';
import GrilleMixedTemplate from './grille-mixed.html';

export default {
	template: GrilleMixedTemplate,
	controller: GrilleMixedController
};
